module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_lexique_remoteEntry_mjs_c0dfd33c__;